import { installFrontendErrorReporting } from "../../resources/js/core/utils/frontendErrorReporter";

installFrontendErrorReporting("legacy");
